import React, {useMemo} from "react";
import {router} from "@inertiajs/react";
import useStatisticsData from "../Statistics/useStatisticsData.js";
import {formatNumber} from "../Statistics/format.js";
import {formatDuration} from "./format.js";
import NutzungWidget from "./NutzungWidget.jsx";

const LIMIT = 10;

function gehezuProfil(userId) {
    router.get(`/nutzung/mitarbeiter/${userId}`);
}

/**
 * Kompakte Rangliste für den Überblick - Klick auf eine Zeile öffnet das
 * vollständige Profil. Die ausführliche, sortierbare Tabelle lebt auf der
 * eigenen Mitarbeiter-Seite (siehe NutzungMitarbeiterTabelle).
 */
export default function NutzungMitarbeiterRangliste({filters}) {
    const {data, loading, error} = useStatisticsData("/nutzung/daten/mitarbeiter", filters);
    const rows = useMemo(() => {
        const liste = Array.isArray(data) ? data : [];
        return [...liste].sort((a, b) => (b.aktive_sekunden || 0) - (a.aktive_sekunden || 0)).slice(0, LIMIT);
    }, [data]);

    return (
        <NutzungWidget
            title="Meistaktive Mitarbeiter"
            help="Die zehn Mitarbeiter mit der meisten aktiven Zeit im gewählten Zeitraum und Filter. Vollständige, sortierbare Liste unter „Mitarbeiter“."
            loading={loading}
            error={error}
            empty={!loading && !error && rows.length === 0}
            height={340}
        >
            <ul className="list-unstyled mb-0">
                {rows.map((row, index) => (
                    <li
                        key={row.user_id}
                        role="button"
                        tabIndex={0}
                        className="d-flex align-items-center justify-content-between gap-2 py-1 border-bottom"
                        style={{cursor: "pointer"}}
                        onClick={() => gehezuProfil(row.user_id)}
                        onKeyDown={(event) => {
                            if (event.key === "Enter" || event.key === " ") {
                                event.preventDefault();
                                gehezuProfil(row.user_id);
                            }
                        }}
                    >
                        <span className="text-truncate">
                            <span className="text-muted small me-2">{index + 1}.</span>
                            {row.name || `Nutzer ${row.user_id}`}
                        </span>
                        <span className="text-end small">
                            <span className="d-block fw-semibold">{formatDuration(row.aktive_sekunden)}</span>
                            <span className="d-block text-muted">{formatNumber(row.aktionen)} Aktionen</span>
                        </span>
                    </li>
                ))}
            </ul>
        </NutzungWidget>
    );
}
